<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <DatesPrevisionnelles v-if="estReservation"></DatesPrevisionnelles>
  <RechercheFormation />
  <ListeModules />
  <Module />
  <ChoixTypeModule />


</template>

<script setup lang="ts">
  import DatesPrevisionnelles from '@/features/interface/demande/cxpi/steps/formation/sections/DatesPrevisionnelles/DatesPrevisionnelles.vue'
import { DEMANDE_STORE } from '@/features/interface/demande/shared'
import { storeToRefs } from 'pinia'
import { inject } from 'vue'

import ChoixTypeModule from './modal/ChoixTypeModule.vue'
import ListeModules from './sections/list/ListeModulesSection.vue'
import Module from './sections/module/ModuleSection.vue'
import RechercheFormation from './sections/recherche/RechercheFormationSection.vue'

  const store = inject(DEMANDE_STORE)!.getStore('MODEL_CXPI')
  const { estReservation } = storeToRefs(store)
</script>
